module.exports = __webpack_public_path__ + "static/tymora-DND3_FnP-630fa24e331f58854f47aaeebd492c9c.jpg";